<template>
    <div v-if="cta" class="vp-cta vp-panel" noautohide>
        <img v-if="cta.image" :src="cta.image" alt="" class="vp-cta-image" />
        <span class="vp-cta-title">{{ formatCtaTitle(cta.title) }}</span>
        <a :href="cta.url" target="_blank" rel="noopener noreferrer" class="vp-cta-button" @click="emit('click', cta)">{{ cta.button }}</a>
        <button type="button" class="vp-icon-button vp-cta-dismiss" :aria-label="t('Dismiss')" @click="emit('dismiss', cta)">
            <VideoIcon name="close" :size="18" />
        </button>
    </div>
</template>

<script setup>
import VideoIcon from "./VideoIcon.vue"
import { formatCtaTitle } from "../../Player/helpers.js"
import { useCoreI18n } from "../useCoreI18n.js"

defineProps({
    cta: { type: Object, default: null },
})

const emit = defineEmits(["click", "dismiss"])

const t = useCoreI18n()
</script>

<style>
.vp-cta {
    position: relative;
    z-index: 1;
    align-self: flex-start;
    width: min(576px, calc(100% - 48px));
    margin: 0 24px 4px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    background: rgba(21, 18, 13, 0.9);
}

.vp-cta-image {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 10px;
    object-fit: cover;
    background: var(--vp-brand);
}

.vp-cta-title {
    min-width: 0;
    flex-grow: 1;
    font-size: 15px;
    font-weight: 600;
    color: var(--vp-paper);
}

.vp-cta-button {
    height: 40px;
    flex-shrink: 0;
    padding: 0 16px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    color: var(--vp-cta-text);
    text-decoration: none;
    background: var(--vp-cta);
}

.vp-cta-dismiss {
    color: var(--vp-muted);
}

media-controller:not([breakpointsm]) .vp-cta-image {
    display: none;
}
</style>
